function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import find from 'lodash/find';
import get from 'lodash/get';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import { AppContext } from 'context';
import SessionStorage from 'libs/SessionStorage';
import history from 'helpers/history';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import PasswordModal from './PasswordModal';
import ProfileBox from './ProfileBox';
import NoIdentityStatement from './NoIdentityStatement';
var _React_PureComponent;
class SwitchIdentity extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress && !state.isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    onBack() {
        if (this.blsReturnUrl) {
            this.context.externalRedirect(this.blsReturnUrl);
            return;
        }
        history.push(this.backUrl);
    }
    onSwitch(identity, password = undefined) {
        this.props.onSwitchIdentity(identity, password);
    }
    onClick(identity) {
        const { loadedIdentity } = this.props;
        if (identity.identityProviderKey !== loadedIdentity.identityProviderKey) {
            this.setState({
                identity
            });
            this.props.onOpenModal();
            return;
        }
        this.onSwitch(identity);
    }
    get identities() {
        const { loadedIdentity } = this.props;
        const scopeTypes = [
            ...constants.BUSINESS_SCOPES,
            ...constants.PRIVATE_SCOPES
        ];
        const getScopeIdx = (identity)=>scopeTypes.findIndex((st)=>st === identity.scope);
        const getCountryName = (identity)=>{
            const { countryCode: alpha2Code } = identity;
            const country = find(this.props.countries, {
                alpha2Code
            });
            return get(this.props.localizationResources, [
                country.nameKey,
                'value'
            ], country.englishName);
        };
        const app = find(constants.APPS, {
            key: this.props.blsKey
        });
        return this.props.identities.filter((identity)=>identity.identityUID !== loadedIdentity.identityUID && (!app || (isEmpty(app.scopes) || includes(app.scopes, identity.scope)) && (isEmpty(app.countries) || includes(app.countries, identity.countryCode)))).map((identity)=>_object_spread_props(_object_spread({}, identity), {
                scopeIdx: getScopeIdx(identity),
                countryName: getCountryName(identity)
            })).sort((a, b)=>a.countryName.localeCompare(b.countryName) || a.scopeIdx - b.scopeIdx);
    }
    get isInProgress() {
        return this.state.isInProgress && !this.props.openModalId;
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx("header", {
            className: "pageHeader",
            children: /*#__PURE__*/ _jsx("h1", {
                className: "text--h2",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.switchProfile))
            })
        });
    }
    renderInfo() {
        return /*#__PURE__*/ _jsx("p", {
            className: "text--paragraph mb-6",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.switchProfile))
        });
    }
    renderIdentities(identities) {
        return identities.map((identity)=>/*#__PURE__*/ _jsx(ProfileBox, {
                identity: identity,
                isDisabled: this.isInProgress,
                onClick: ()=>this.onClick(identity)
            }, `${identity.scope}-${identity.countryCode}`));
    }
    renderActions() {
        return /*#__PURE__*/ _jsx("div", {
            className: "row",
            children: /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.back,
                    className: "btn--block btn--filled",
                    isInProgress: this.isInProgress,
                    onClick: ()=>this.onBack()
                })
            })
        });
    }
    render() {
        const { identities } = this;
        if (!identities.length) {
            return /*#__PURE__*/ _jsx(NoIdentityStatement, {
                onBack: ()=>this.onBack()
            });
        }
        const { identity } = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "pageContentBox",
                    children: [
                        this.renderHeader(),
                        this.renderInfo(),
                        this.renderIdentities(identities),
                        this.renderActions()
                    ]
                }),
                /*#__PURE__*/ _jsx(PasswordModal, {
                    identity: identity,
                    isInProgress: this.state.isInProgress,
                    onSwitch: (password)=>this.onSwitch(identity, password)
                })
            ]
        });
    }
    constructor(props, context){
        super(props);
        this.backUrl = context.getUrl('app-catalog');
        this.blsReturnUrl = SessionStorage.getItem('blsReturnUrl');
        this.state = {
            identity: null,
            isInProgress: false
        };
    }
}
_define_property(SwitchIdentity, "contextType", AppContext);
_define_property(SwitchIdentity, "propTypes", {
    // Explicit props
    blsKey: PropTypes.string,
    // Implicit props
    identities: PropTypes.arrayOf(shapes.identity),
    loadedIdentity: shapes.identity,
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    openModalId: PropTypes.string,
    isInProgress: PropTypes.bool.isRequired,
    hasErrors: PropTypes.bool.isRequired,
    // Implicit actions
    onSwitchIdentity: PropTypes.func,
    onOpenModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        identities: selectors.identities(state),
        loadedIdentity: selectors.loadedIdentity(state),
        isInProgress: selectors.isSwitchIdentityInProgress(state),
        hasErrors: selectors.hasSwitchIdentityErrors(state),
        countries: App.selectors.countries(state),
        localizationResources: App.selectors.localizationResources(state),
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSwitchIdentity: (identity, password)=>dispatch(actions.switchIdentity(identity, password)),
        onOpenModal: ()=>dispatch(App.actions.openModal(constants.IDENTITY_PASSWORD_MODAL))
    });
const ConnectedSwitchIdentity = connect(mapStateToProps, mapDispatchToProps)(SwitchIdentity);
export default ConnectedSwitchIdentity;
